var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWodLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "45px",
    viewBox: "0 0 39 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Identity-server",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modules-apps",
    transform: "translate(-177.000000, -64.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 3.000000)",
    id: "Asset-15"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(173.000000, 61.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.15,0 L0,11.05 L0,33.16 L19.15,44.22 L38.29,33.16 L38.29,11.05 L19.15,0 Z M14,18.52 L8.74,18.52 L8.74,21 L13.61,21 L13.61,23.09 L8.74,23.09 L8.74,25.61 L14,25.61 L14,27.7 L6.52,27.7 L6.52,16.42 L14,16.42 L14,18.52 Z M36.31,32 L19.21,41.88 L19.21,30.63 L21.88,28 L24.66,30.78 L32.66,22.78 L33.86,23.98 L34.86,19.06 L29.97,20.06 L31.28,21.37 L24.68,27.97 L21.9,25.19 L19.21,27.8 L19.21,26.65 C19.29,26.23 19.46,25.65 19.51,25.45 C20.0745096,23.7418337 21.4773317,22.4437053 23.22407,22.013114 C24.9708082,21.5825227 26.8162475,22.0799169 28.11,23.33 L29.5,21.89 C28.8696715,21.2853062 28.1342947,20.8007031 27.33,20.46 C28.8074793,18.9159684 28.7715912,16.4717453 27.2494173,14.971757 C25.7272433,13.4717688 23.2827567,13.4717688 21.7605827,14.971757 C20.2384088,16.4717453 20.2025207,18.9159684 21.68,20.46 C20.7395822,20.8580863 19.8943104,21.4511399 19.2,22.2 L19.2,2.36 L36.3,12.24 L36.31,32 Z M22.62,17.76 C22.62,16.7051361 23.4751361,15.85 24.53,15.85 C25.5848639,15.85 26.44,16.7051361 26.44,17.76 C26.44,18.8148639 25.5848639,19.67 24.53,19.67 C23.4751361,19.67 22.62,18.8148639 22.62,17.76 L22.62,17.76 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWodLogo);
export default __webpack_public_path__ + "static/media/wodLogo.2ac855f0.svg";
export { ForwardRef as ReactComponent };